'use strict';

export { CSSKeyframesRuleImpl, CSSManager } from "./web/index.js";
//# sourceMappingURL=platform.js.map